import { useEffect } from 'react';

export default function SeoHelmet({ title, description }) {
  useEffect(() => {
    document.title = title ? `${title} - Avalio` : 'Avalio';
    if (description) document.querySelector('meta[name="description"]')?.setAttribute('content', description);
  }, [title, description]);

  return null;
}
